import React from 'react';
import CarouselBackground from '../CarouselBackground/CarouselBackground';
import './Hero.css';

const IconHelmet = () => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 5C13.3 5 7.2 11.1 7 18.8H6C5.4 18.8 5 19.2 5 19.8V23c0 .6.4 1 1 1h30c.6 0 1-.4 1-1v-3.2c0-.6-.4-1-1-1h-1C34.8 11.1 28.7 5 21 5Z" stroke="#22c55e" strokeWidth="1.8" strokeLinejoin="round"/>
    <line x1="21" y1="5" x2="21" y2="18.8" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="5" y1="28" x2="37" y2="28" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round"/>
    <path d="M10 28L8.5 36H33.5L32 28" stroke="#22c55e" strokeWidth="1.8" strokeLinejoin="round"/>
  </svg>
);

const IconTarget = () => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="21" cy="21" r="15" stroke="#22c55e" strokeWidth="1.8"/>
    <circle cx="21" cy="21" r="9" stroke="#22c55e" strokeWidth="1.8"/>
    <circle cx="21" cy="21" r="3.5" fill="#22c55e"/>
    <line x1="21" y1="6" x2="21" y2="11" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="21" y1="31" x2="21" y2="36" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="6" y1="21" x2="11" y2="21" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="31" y1="21" x2="36" y2="21" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const IconShield = () => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 4L8 9.5V21C8 28.5 13.8 35.2 21 37C28.2 35.2 34 28.5 34 21V9.5L21 4Z" stroke="#22c55e" strokeWidth="1.8" strokeLinejoin="round"/>
    <path d="M15 21L19 25L27 17" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconHandshake = () => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 16L13 12L21 17L29 12L38 16" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 16V26L13 30L21 25L29 30L38 26V16" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="13" y1="12" x2="13" y2="30" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="29" y1="12" x2="29" y2="30" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="21" y1="17" x2="21" y2="25" stroke="#22c55e" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

const FEATURES = [
  {
    icon: <IconHelmet />,
    title: ['Ejecución', 'de Calidad'],
    description: 'Cumplimos estándares técnicos en cada etapa del proyecto.',
  },
  {
    icon: <IconTarget />,
    title: ['Entrega', 'a Tiempo'],
    description: 'Planificamos y ejecutamos con eficiencia para cumplir cada compromiso.',
  },
  {
    icon: <IconShield />,
    title: ['Seguridad', 'Garantizada'],
    description: 'Aplicamos protocolos y mejores prácticas para proteger a nuestro equipo y al proyecto.',
  },
  {
    icon: <IconHandshake />,
    title: ['Compromiso', 'Total'],
    description: 'Trabajamos con transparencia, responsabilidad y enfoque en resultados.',
  },
];

const Hero = () => {
  const scrollToProjects = (e) => {
    e.preventDefault();
    document.querySelector('#projects')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = (e) => {
    e.preventDefault();
    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero">
      <CarouselBackground overlayVariant="dark" showDots />

      <div className="hero__content">
        <div className="hero__eyebrow">
          <div className="hero__eyebrow-line" />
          <span className="hero__eyebrow-text">Empresa Constructora y Supervisora — Honduras</span>
        </div>

        <h1 className="hero__heading">
          <span className="hero__heading-line">Ingeniería</span>
          <span className="hero__heading-line">
            <em>Confiable.</em>
          </span>
        </h1>

        <div className="hero__body">
          <div className="hero__body-left">
            <p className="hero__description">
              Construimos proyectos que combinan experiencia, planificación
              y calidad, ofreciendo soluciones confiables para el desarrollo
              de infraestructura y edificaciones.
            </p>

            <div className="hero__actions">
              <a href="#projects" className="btn-primary" onClick={scrollToProjects}>
                Ver proyectos
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8H13M13 8L8 3M13 8L8 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
              <a href="#contact" className="btn-outline" onClick={scrollToContact}>
                Cotizar obra
              </a>
            </div>
          </div>

          <div className="hero__features">
            {FEATURES.map((feat) => (
              <div key={feat.title[0]} className="hero__feature">
                <div className="hero__feature-icon">{feat.icon}</div>
                <div className="hero__feature-title">
                  {feat.title[0]}<br />{feat.title[1]}
                </div>
                <p className="hero__feature-desc">{feat.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="hero__scroll">
        <div className="hero__scroll-line" />
        <span className="hero__scroll-text">Scroll</span>
      </div>
    </section>
  );
};

export default Hero;
